@if (voucherType) {
    <div class="flex-column gap-x-small wrapper">
        <app-select-input
            id="medicalProcedureCode"
            class="flex-1" [form]="form"
            [infiniteScroll]="store.proceduresScroll()"
            [dataKey]="null"
            [valueKey]="null"
            idField="code"
            label="database.vouchers.prescriptions.prescribeNewProcedure"
            filterBy="code,customCode,customName,description"
            [autoDisplayFirst]="false"
        >
            <ng-template #item let-item>
                <div class="procedure-item">{{ item | formatServiceProcedure }}</div>
            </ng-template>
            <ng-template #selectedItem let-item>
                <div class="procedure-item">{{ item | formatServiceProcedure }}</div>
            </ng-template>
        </app-select-input>

        <app-table
            [items]="prescriptionItems()"
            [columns]="columns()"
            [hideCheckboxes]="true"
            [showColumnVisiblity]="true"
            [showPagination]="false"
            translatePrefix="voucher.prescriptions."
            dataKey="serviceMedicalProcedureId"
            [showDelete]="folderStore.canEdit()"
            (deleteCallbackWithEvent)="openDeleteConfirmation($event)"
        >
            <ng-template pTemplate="description" let-item="item">
                <app-strip-and-show [text]="(item | transformSingleVoucherPrescription)[0].description"
                    [length]="50"></app-strip-and-show>
            </ng-template>

            <ng-template pTemplate="canBeBilled" let-item="item">
                <p-checkbox [disabled]="!folderStore.canEdit()"
                    [(ngModel)]="item['canBeBilled']" [binary]="true"></p-checkbox>
            </ng-template>

            <ng-template pTemplate="canBeBilledWeekend" let-item="item">
                <p-checkbox [disabled]="!folderStore.canEdit()"
                    [(ngModel)]="item['canBeBilledWeekend']" [binary]="true"></p-checkbox>
            </ng-template>

            <ng-template pTemplate="canBeBilledNight" let-item="item">
                <p-checkbox [disabled]="!folderStore.canEdit()"
                    [(ngModel)]="item['canBeBilledNight']" [binary]="true"></p-checkbox>
            </ng-template>

            <ng-template pTemplate="continuousOperation" let-item="item">
                <p-checkbox [disabled]="!folderStore.canEdit()"
                    [(ngModel)]="item['continuousOperation']" [binary]="true"></p-checkbox>
            </ng-template>

            <ng-template pTemplate="courseDescription" let-item="item">
                <app-input-wysiwyg
                    placeholder="voucher.prescriptions.fields.courseDescription"
                    [editInModal]="true"
                    [disabled]="!folderStore.canEdit()"
                    [defaultValue]="item['courseDescription']"
                    [useBackup]="false"
                    (blurred)="editField($event, 'courseDescription', item)"
                ></app-input-wysiwyg>
            </ng-template>

            <ng-template pTemplate="recordTemplate" let-item="item">
                <app-input-wysiwyg
                    placeholder="voucher.prescriptions.fields.recordTemplate"
                    [editInModal]="true"
                    [disabled]="!folderStore.canEdit()"
                    [defaultValue]="item['recordTemplate']"
                    [useBackup]="false"
                    (blurred)="editField($event, 'recordTemplate', item)"
                ></app-input-wysiwyg>
            </ng-template>

            <ng-template pTemplate="usualNumberOfApplications" let-item="item">
                <p-select
                    [disabled]="!folderStore.canEdit()"
                    [options]="usualNumberOfApplicationsOptions"
                    [optionLabel]="'value'"
                    [optionValue]="'value'"
                    appendTo="body"
                    [ngModel]="item['usualNumberOfApplications']"
                    (ngModelChange)="editField($event, 'usualNumberOfApplications', item)"
                >
                </p-select>
            </ng-template>

            <ng-template pTemplate="frequency" let-item="item">
                <input
                    pInputText
                    type="text"
                    [value]="item['frequency']"
                    [disabled]="!folderStore.canEdit()"
                    [placeholder]="'voucher.prescriptions.fields.frequency' | translate"
                    (change)="editField($event.target.value, 'frequency', item)">
            </ng-template>
        </app-table>
    </div>
}

<p-dialog [header]="'database.vouchers.prescriptions.cannotDeleteProcedure.header' | translate"
    [(visible)]="cannotDeleteWarningVisible" [modal]="true" [draggable]="false" [resizable]="false"
    (onHide)="cannotDeleteWarningVisible = false">
    <div class="warning-message">
        <i class="pi pi-exclamation-triangle"></i>
        {{ 'database.vouchers.prescriptions.cannotDeleteProcedure.label' | translate }}
    </div>
</p-dialog>
